if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      tabsListItems = undefined;
      tabsContentItems = undefined;

      constructor() {
        super();

        this.tabsListItems = this.querySelectorAll('.tabs-list .tabs-trigger');
        this.tabsContentItems = this.querySelectorAll('.tabs-content');
      }

      connectedCallback() {
        this.initTabs();
      }

      initTabs() {
        if (!this.tabsListItems.length || !this.tabsContentItems.length) return;

        this.tabsListItems.forEach((trigger, idx) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.activateTab(idx);
          });
          trigger.setAttribute('role', 'tab');
          trigger.setAttribute('tabindex', idx === 0 ? '0' : '-1');
          trigger.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        });

        this.tabsContentItems.forEach((content, idx) => {
          content.setAttribute('role', 'tabpanel');
          content.classList.toggle('active', idx === 0);
          content.hidden = idx !== 0;
        });
      }

      activateTab(index) {
        this.tabsListItems.forEach((trigger, idx) => {
          trigger.classList.toggle('active', idx === index);
          trigger.setAttribute('aria-selected', idx === index ? 'true' : 'false');
          trigger.setAttribute('tabindex', idx === index ? '0' : '-1');
        });
        this.tabsContentItems.forEach((content, idx) => {
          content.classList.toggle('active', idx === index);
          content.hidden = idx !== index;
        });
      }
    }
  );
}
